import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import { Spinner } from "./components/commonComponents/Spinner/Spinner";
import { Box } from "@mui/material";
import Billing from "./features/billing/Billing";
import DeviceManagement from "./features/DeviceManagement/DeviceManagement";
import Order from "../src/features/order/Order";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSocket from "./features/customerManagement/hooks/useSocket";
import { accountId } from "./features/customerManagement/utility/authUtils";
import HelpBadge from "./features/HelpBadge/HelpBadge";
import SupportTicketsPanel from "./features/HelpBadge/SupportTicketsPanel";
// import { ApiDoc } from "./features/API_DOCUMENTATION/ApiDoc";
import ExcelUpload from "./features/bulkWhitlist/ExcelUpload";
import TransactionExcelUpload from "./features/bulkTransactions/TransactionExcelUpload";
import ApiDoc from "./features/API_DOCUMENTATION/ApiDoc";
import ViewDetails from "./features/HelpBadge/ViewDetails";
import ProfileManagement from "./features/ProfileManagement/ProfileManagement";
import { View } from "lucide-react";

// Lazy load route components
const LoginPage = lazy(() => import("./features/login/Login"));
const DashboardPage = lazy(() => import("./features/dashboard/Dashboard"));
const Inventory = lazy(() => import("./features/Inventory/Inventory"));
const ProfileInventory = lazy(() =>
  import("./features/Inventory/ProfileInventory")
);
const Drawer = lazy(() => import("./components/layout/Header"));
const Vendor = lazy(() => import("./features/vendor/VendorList"));
const AddVendor = lazy(() => import("./features/vendor/AddVendor"));
const ProfilePage = lazy(() => import("./components/Profile/Profile"));
const Demo = lazy(() => import("./"));

const SimActivationRequest = lazy(() =>
  import("./features/simActivation/SimActivationRequest")
);
const AddSimActivation = lazy(() =>
  import("./features/simActivation/AddSimActivation")
);
const AddKyc = lazy(() => import("./features/kycMaster/AddKYC"));
const KYCMaster = lazy(() => import("./features/kycMaster/KycMaster"));

const ErrorPage = lazy(() =>
  import("./components/commonComponents/Error/Error")
);
const BulkTransaction = lazy(() =>
  import("./features/bulkTransactions/BulkTransaction")
);
const BulkWhiteList = lazy(() =>
  import("./features/bulkWhitlist/BulkWhiteList")
);
const AdminDashboard = lazy(() =>
  import("./features/customerManagement/AdminDashboard")
);
const PlanManagement = lazy(() =>
  import("./features/planManagement/PlanManagement")
);
const Reports = lazy(() => import("./features/reports/Reports"));
const AuditTrails = lazy(() => import("./features/auditTrails/AuditTrails"));
const WhiteListing = lazy(() => import("./features/whiteListing/whiteListing"));
const USerManual = lazy(() => import("./features/ResourceCenter/USerManual"));
const SelfLearningGuide = lazy(() =>
  import("./features/ResourceCenter/SelfLearningGuide")
);
const ViewRequest=lazy (()=> import("./features/viewRequest/ViewRequest"))

const App = () => {
  useEffect(() => {
    const savedColor = localStorage.getItem("themeColor") || "#4151e0";
    document.documentElement.style.setProperty("--bg", savedColor);
    document.documentElement.style.setProperty("--drawerColor", savedColor);
  }, []);

  //  useSocket(accountId());
  return (
    <Box sx={{ display: "flex" }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Router>
        <SocketListener />
        <Suspense fallback={<Spinner />}>
          <Drawer />
          <Box sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/demo"
                element={
                  <PrivateRoute>
                    <Demo />
                  </PrivateRoute>
                }
              />

              <Route
                path="/DeviceManagement"
                element={
                  <PrivateRoute>
                    <DeviceManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/APIDOC"
                element={
                  <PrivateRoute>
                    <ApiDoc />
                  </PrivateRoute>
                }
              />
              <Route
                path="/order"
                element={
                  <PrivateRoute>
                    <Order />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profileInventory"
                element={
                  <PrivateRoute>
                    <ProfileInventory />
                  </PrivateRoute>
                }
              />
              <Route
                path="/adminDashboard"
                element={
                  <PrivateRoute>
                    <AdminDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/planManagement"
                element={
                  <PrivateRoute>
                    <PlanManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/physicalInventory"
                element={
                  <PrivateRoute>
                    <Inventory />
                  </PrivateRoute>
                }
              />
               <Route
                path="/ViewRequest"
                element={
                  <PrivateRoute>
                    <ViewRequest />
                  </PrivateRoute>
                }
              />

              <Route
                path="/vendor"
                element={
                  <PrivateRoute>
                    <Vendor />
                  </PrivateRoute>
                }
              />

              <Route
                path="/profilemanagement"
                element={
                  <PrivateRoute>
                  <ProfileManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/billing"
                element={
                  <PrivateRoute>
                    <Billing />
                  </PrivateRoute>
                }
              />
              <Route
                path="/addVendor"
                element={
                  <PrivateRoute>
                    <AddVendor />
                  </PrivateRoute>
                }
              />

              {/* ADITYA NARAYAN MOHANTY > */}
              <Route
                path="/simActivation"
                element={
                  <PrivateRoute>
                    <SimActivationRequest />
                  </PrivateRoute>
                }
              />
              <Route
                path="/addSimActivation"
                element={
                  <PrivateRoute>
                    <AddSimActivation />
                  </PrivateRoute>
                }
              />
              {/* < ADITYA NARAYAN MOHANTY */}

              <Route
                path="/kyc"
                element={
                  <PrivateRoute>
                    <KYCMaster />
                  </PrivateRoute>
                }
              />

              <Route
                path="/addKyc"
                element={
                  <PrivateRoute>
                    <AddKyc />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/auditTrails"
                element={
                  <PrivateRoute>
                    <AuditTrails />
                  </PrivateRoute>
                }
              />

              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bulktransaction"
                element={
                  <PrivateRoute>
                    <BulkTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="/transactionexcelupload"
                element={
                  <PrivateRoute>
                    <TransactionExcelUpload />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bulkWhitelist"
                element={
                  <PrivateRoute>
                    <BulkWhiteList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/excelUploadwhiteList"
                element={
                  <PrivateRoute>
                    <ExcelUpload />
                  </PrivateRoute>
                }
              />

              <Route
                path="/whiteList"
                element={
                  <PrivateRoute>
                    <WhiteListing />
                  </PrivateRoute>
                }
              />
              <Route
                path="/support"
                element={
                  <PrivateRoute>
                    <SupportTicketsPanel />
                  </PrivateRoute>
                }
              />
              <Route
                path="/viewDetails"
                element={
                  <PrivateRoute>
                    <ViewDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/userManual"
                element={
                  <PrivateRoute>
                    <USerManual />
                  </PrivateRoute>
                }
              />
              <Route
                path="/selflearning"
                element={
                  <PrivateRoute>
                    <SelfLearningGuide />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </Box>
          {/* <HelpBadge /> */}
        </Suspense>
      </Router>
    </Box>
  );
};

export default App;

function SocketListener() {
  useSocket(accountId());
  return null;
}
